import { __awaiter } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import { filterElementsBySize } from 'pathfinder/modules/ImageGalleryIcon/utils/filterElementsBySize';
import { getElementsWithLightbox } from 'pathfinder/modules/ImageGalleryIcon/utils/getElementsWithLightbox';
import { getFilteredImages } from 'pathfinder/modules/ImageGalleryIcon/utils/getFilteredImages';
const VIGNETTE_SERVER = 'https://static.wikia.nocookie.net/';
export const getImageGalleryIconModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const moduleProps = buildModuleProps(moduleConfig, {});
    const { log } = moduleProps;
    // check WikiConfig variable if it has gallery enabled
    const hasGalleryEnabled = window.mw.config.get('wgEnableLightboxExt');
    if (!hasGalleryEnabled) {
        log.error('ImageGalleryIcon: lightbox extension is not enabled');
        return null;
    }
    const parentElement = document.querySelector('.mw-parser-output');
    if (!parentElement) {
        log.debug(`ImageGalleryIcon: Cannot find element with selector "${parentElement}"`);
        return null;
    }
    const elementsWithLightbox = getElementsWithLightbox(parentElement);
    // do not show module if wiki doesn't have images with lightbox
    if (elementsWithLightbox.length === 0) {
        log.debug(`ImageGalleryIcon: Wiki doesn't have images with lightbox`);
        return null;
    }
    const elementsWithProperSize = filterElementsBySize(elementsWithLightbox);
    // do not show module if images don't pass size requirements
    if (elementsWithProperSize.length === 0) {
        log.debug(`ImageGalleryIcon: There are no images with proper size`);
        return null;
    }
    const filteredImages = getFilteredImages(elementsWithProperSize);
    try {
        // lazy load component
        const ImageGalleryIconModule = yield import(
        /* webpackChunkName: "ImageGalleryIconModule" */ './ImageGalleryIconModule');
        const render = () => {
            filteredImages.map((image) => {
                const reactRoot = document.createElement('div');
                reactRoot.style.position = 'absolute';
                reactRoot.style.bottom = '0px';
                reactRoot.style.right = '0px';
                reactRoot.style.width = '100%';
                reactRoot.style.height = '100%';
                const figureElement = image.closest('figure');
                const imageParentElement = image.parentElement;
                if (figureElement && figureElement.classList.contains('show-info-icon')) {
                    const infoIcon = figureElement.querySelector('.info-icon');
                    if (infoIcon) {
                        infoIcon.style.display = 'none';
                    }
                }
                const placement = figureElement && figureElement.classList.contains('pi-image') ? 'infobox' : 'in-content';
                // check if parent is an anchor and leads to an image
                if (imageParentElement instanceof HTMLAnchorElement && imageParentElement.href.includes(VIGNETTE_SERVER)) {
                    imageParentElement.style.display = 'inline-block';
                    imageParentElement.style.position = 'relative';
                    imageParentElement.insertAdjacentElement('beforeend', reactRoot);
                }
                moduleProps.config = {
                    placement,
                    imageElement: image,
                    anchorElement: imageParentElement,
                };
                ReactDOM.render(React.createElement(ImageGalleryIconModule.default, moduleProps), reactRoot);
                return reactRoot;
            });
        };
        return {
            render,
        };
    }
    catch (error) {
        log.debug('ImageGalleryIconModule error', error);
    }
    return null;
});
